/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React,{useState} from 'react'

export const AddressDrop = (props)=>{
    const {list,type,setselectedAddressObj,selectedAddressObj,prod,handleClose,toggleSwitch} =props;

    const handleAddressSelect=(item)=>{
        handleClose();
        const copy = {...selectedAddressObj};
        if (copy[prod.item_id] === undefined)
            copy[prod.item_id] = {}
        copy[prod.item_id][type]=item
        setselectedAddressObj(copy);
        toggleSwitch(false)
        return;

    }
    
    
    const handleCheck = (add)=>{
        return  selectedAddressObj[prod?.item_id][type]?.unique_id===add?.unique_id
    }
    const [searchKey, setsearchKey] = useState('');
    const handleSearch=(val)=>{
        if (searchKey === "") {
            return val;
        } else if (val?.ADDRESS1?.toLowerCase().includes(searchKey.toLowerCase()) 
        ||val?.ADDRESS2?.toLowerCase().includes(searchKey.toLowerCase())
        ||val?.ADDRESS3?.toLowerCase().includes(searchKey.toLowerCase()) 
        || val?.ADDRESS4?.toLowerCase().includes(searchKey.toLowerCase())
        ||val?.POSTAL_CODE?.toLowerCase().includes(searchKey.toLowerCase())) {
            return val;
        }
    }
    return(
        <>
            <input  onChange={(e)=>setsearchKey(e.target.value)} className="block w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg" placeholder="Search..." />

            {list && list[type].filter((val)=>handleSearch(val)).map((add,i)=>(
                <li key={i} className="w-full bg-[#ffffff] hover:bg-[#F5F5FA] rounded-md pl-1 py-1">
                    <div className="relative checkbox custom-checkbox custom-radio2 flex items-center dropdown-item" onClick={(e)=>{
                        e.preventDefault();
                        handleAddressSelect(add)}}>
                        <input type="radio"
                            id={`${add?.unique_id}`} 
                            name={add?.unique_id}
                            checked={handleCheck(add)}
                            className="cursor-pointer" />
                        <label htmlFor={`checkbox-${add?.unique_id}`} className="text-sm font-normal text-[#555259] pl-4 cursor-pointer mt-[3px]">
                            <>{add?.ADDRESS1}</>,<>{add?.ADDRESS2}</>,
                            <>{add?.ADDRESS3}</><br/> {add?.ADDRESS4}
                            <>{`${add?.CITY}`} -{`${add?.POSTAL_CODE}`},{`${add?.STATE}`},
                                {`GSTIN-${add?.SITE_GSTIN || '-'}`}</>
                        </label>
                    </div>
                </li>
            ))}
        </>
    )
}
